import { AutoComplete } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { CustomAutoCompleteProps } from '../../interfaces';
import './styles.scss';

const CustomAutoComplete: React.FC<CustomAutoCompleteProps> = props => {
  const { className, ...rest } = props;

  return (
    <AutoComplete
      {...rest}
      className={classNames(className, 'custom-auto-complete')}
    />
  );
};

export default CustomAutoComplete;
